<template>
  <div class="main-wrapper party-edit">
    <v-container>
      <v-row>
        <v-col>
          <v-alert
            v-if="peSurveysValidationActive"
            outlined
            type="warning"
          >
            <v-row>
              <v-col cols="auto">
                Party Survey Mode Activated!
              </v-col>
              <v-spacer />
              <v-btn
                color="secondary"
                class="mt-1"
                @click="peSurveyDeactivateValidation"
              >
                Leave Mode
              </v-btn>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
      <v-row :class="peOverviewSummaryCollapsed ? 'collapsed' : 'not-collapsed'">
        <v-col
          cols="auto"
        >
          <v-navigation-drawer
            permanent
            expand-on-hover
            :height="null"
            class="d-sticky elevation-2"
          >
            <v-list
              nav
              dense
            >
              <v-list-item-group v-model="selectedSection">
                <v-list-item
                  v-for="section of sections"
                  :key="section.route"
                  :to="section.route"
                  link
                >
                  <v-list-item-icon>
                    <v-icon>{{ section.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ section.title }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-col>
        <v-col>
          <PEHeader />
          <router-view />
        </v-col>
      </v-row>
    </v-container>

    <PEOverviewSummary />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { PARTY_EDIT_SECTIONS } from '@/router/party-edit'
import { PARTY_NAMESPACE } from '@/store/party'
import PEHeader from '@/components/Party/PartyEdit/PEHeader.vue'
import PEOverviewSummary from '@/components/Party/PartyEdit/PEOverviewSummary.vue'
import { alertHandler } from '@/alertHandler'

export default {
  name: 'PartyEdit',

  components: {
    PEHeader,
    PEOverviewSummary,
  },

  setup () {
    return { ...alertHandler() }
  },

  data () {
    return {
      sections: PARTY_EDIT_SECTIONS,
      selectedSection: null,
    }
  },

  computed: {
    ...mapGetters(PARTY_NAMESPACE, [
      'peOverviewSummaryCollapsed',
      'peSurveysValidationActive',
    ]),
  },

  destroyed () {
    this.peResetPartyEdit()
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peResetPartyEdit',
      'peSurveyDeactivateValidation',
    ]),
  },
}
</script>

<style scoped lang="scss">
.d-sticky {
  position: sticky!important;
  top: 72px !important;
  z-index: 1 !important;

  &::before {
    position: absolute;
    z-index: -1;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background: linear-gradient(180deg,rgba(var(--v-background-base),70%) 44%,rgba(var(--v-background-base),43%) 73%,rgba(var(--v-background-base),0%));
    background-repeat: repeat;
    block-size: calc(64px + 1.25rem);
    content: "";
    inset-block-start: -1.25rem;
    inset-inline-end: 0;
    inset-inline-start: 0;
    -webkit-mask: linear-gradient(black,black 18%,transparent 100%);
    mask: linear-gradient(black,black 18%,transparent 100%);
  }
  &::after{
    position: absolute;
    content: "";
    z-index: -1;
    background: inherit;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
  }
}
</style>
